<template>
  <div id="atlas-introduction" class="atlas-introduction">
        <p v-for="(title) in titles" 
            :key="title"
            class="atlas-introduction__title"
        >
            {{ title }}
         </p>
        <p class="atlas-introduction__en-title">{{ en_title }}</p>
        <p v-for="(update_message) in update_messages" 
            :key="update_message"
            class="atlas-introduction__update-msg"
        >
            {{ update_message }}
         </p>
  </div>
</template>

<script>
export default {
    name: 'atlas-introduction',

    props: {
        titles: {
            type: Array,
            required: true
        },
        
        en_title: {
            type: String,
            default: ''
        },

        update_messages: {
            type: Array,
            required: true
        },
    }
}
</script>

<style lang="scss" scoped>
    .atlas-introduction {
        width: 100%;
        padding: 6px 16px;
        background: var(--base-blue-lighten);
        font-size: 1.8vh;
        text-align: center;

        p {
            text-align: center;
            margin-bottom: 0em;
            letter-spacing: 1px;
        }

        &__title {
            color: #ffffff;
            font-size: 18px;
            line-height: 28px;
            font-weight: bold;
        }

        &__en-title {
            font-size: 12px;
            line-height: 20px;
            color: #ffffff;
        }

        &__update-msg {
            font-size: 14px;
            line-height: 20px;
            color: var(--aqua-active);
        }
    }
</style>